<nav #container class="navbar navbar-expand border-bottom p-0 pr-3">
  <epc-brand-indicator></epc-brand-indicator>

  <ul class="navbar-nav d-none d-lg-flex ml-lg-5">
    <ng-container
      *epcFeatureFlag="
        homeAndBrowseEnabledFlag;
        namespace: navigationNamespace;
        equality: true;
        defaultValue: false
      "
    >
      @for (navigation of navigationPoints; track trackByRoute($index,
      navigation)) {
      <li class="nav-item">
        <epc-nav-link
          [listGroupAction]="false"
          [label]="navigation.label"
          [route]="navigation.route"
          [name]="navigation.name"
          [queryParams]="
            navigation.appendSearchParams
              ? (searchQueryParams$ | async)
              : undefined
          "
          [isActive]="navigation.isActive$ | async"
        ></epc-nav-link>
      </li>
      }
    </ng-container>

    @if (myListLink$ | async; as myListsLink) {
    <li class="nav-item" (click)="openAsideMenu()">
      <epc-nav-link
        [listGroupAction]="false"
        [label]="myListsLink.label"
        [route]="myListsLink.route"
        [name]="myListsLink.name"
        [isActive]="myListsLink.isActive$ | async"
        [icon]="bookmarkIcon$ | async"
      ></epc-nav-link>
    </li>
    }
  </ul>

  @if ({ showSearchBarOnMobile: showSearchBarOnMobile$ | async, isMobile:
  isMobile$ | async }; as observables) { @if (observables.isMobile ?
  observables.showSearchBarOnMobile : true) {
  <epc-search-bar class="search-bar ml-xxl-5 ml-3 p-3 p-xl-0"></epc-search-bar>
  }
  <ul class="navbar-nav ml-auto">
    <li class="nav-item d-none d-md-block d-lg-none">
      <a
        class="nav-link px-2"
        routerLink="/scan"
        [routerLinkActive]="'active'"
        data-e2e="scanner-link"
      >
        <fa-icon [icon]="faScan" size="1"></fa-icon>
      </a>
    </li>
    @if (observables.hideSearchBarOnMobile && observables.isMobile) {
    <li class="nav-item d-block d-xl-none">
      <a
        class="nav-link px-2"
        routerLink="/browse/search"
        [routerLinkActive]="'active'"
        data-e2e="p-basket-link"
      >
        <fa-icon [icon]="faSearch" size="1"></fa-icon>
      </a>
    </li>
    }
    <li class="nav-item" class="basket-button-wrapper">
      <epc-basket-button class="h-100"></epc-basket-button>
    </li>
    <ng-container
      *epcFeatureFlag="
        connectEnabledFlag;
        namespace: connectNamespace;
        equality: true;
        defaultValue: false
      "
    >
      <li class="nav-item d-none d-sm-flex">
        <epc-user-contacts></epc-user-contacts>
      </li>
    </ng-container>
    <li class="nav-item" data-e2e="user">
      <epc-user-menu-widget></epc-user-menu-widget>
    </li>
  </ul>
  }
</nav>
